import React, { useEffect, useMemo, useState } from "react";
import MiniDrawer from "../Components/MiniDrawer";
import configData from "../../config.json";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useMediaQuery } from "react-responsive";
import Dropdown from "../Components/Categories/Dropdown";
import axios from "axios";
import moment from "moment";

function PregnancyCare() {
  const isPhone = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });

  const [submenu, setSubmenu] = useState(false);
  const [pregnancycare, setPregnancycare] = useState([]);

  useEffect(() => {
    getdetailpregnancy();
  }, []);

  const showsubmenu = () => {
    setSubmenu(!submenu);
  };

  const getdetailpregnancy = async () => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/get_consultation_summary`,
        {
          patient_id: localStorage.getItem("userId"),
        }
      );
      if (response.data.summary) {
        setPregnancycare(response.data.summary);
      }
    } catch (error) { }
  };

  const getConsultationSummaryText = (consultation) => {
    const consultationSummary = consultation?.summary;
    if (consultationSummary) return consultationSummary;

    const latestPrescriptionSummary = consultation?.prescriptions
      ?.slice()
      .reverse()
      .find((prescription) => prescription?.prescSummary)?.prescSummary;

    return latestPrescriptionSummary || null;
  };

  const getConsultationStatus = (consultation) => {
    if (consultation?.is_completed === 1) {
      return "COMPLETED";
    }

    if (
      consultation?.scheduled_date &&
      moment(consultation.scheduled_date).isBefore(moment())
    ) {
      return "PENDING";
    }

    return "SCHEDULED";
  };

  const getDoctorImage = (consultation) => {
    if (consultation?.file_path) {
      return `${configData.API_URL}${consultation.file_path}`;
    }

    if (consultation?.doctorDetails?.profile_pic) {
      return `${configData.API_URL}${consultation.doctorDetails.profile_pic}`;
    }

    return "/profile/Group-1151.png";
  };


  const summaryStats = useMemo(() => {
    const completed = pregnancycare.filter(
      (item) => getConsultationStatus(item) === "COMPLETED"
    ).length;
    const pending = pregnancycare.filter(
      (item) => getConsultationStatus(item) === "PENDING"
    ).length;

    return {
      total: pregnancycare.length,
      completed,
      pending,
    };
  }, [pregnancycare]);

  const outerwrapper = {
    width: "100%",
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, #FFF5F8 0%, #FFF0F5 42%, #FFFFFF 100%)",
    overflowY: "auto",
  };

  const headerWrap = {
    padding: isPhone ? "18px 16px 14px" : isTablet ? "26px 24px 18px" : "32px",
    borderBottom: "1px solid #F0D8E1",
    background:
      "linear-gradient(135deg, rgba(240,88,139,0.12) 0%, rgba(0,74,173,0.08) 100%)",
    position: "sticky",
    top: 0,
    zIndex: 2,
    backdropFilter: "blur(8px)",
  };

  const heading = {
    fontSize: isPhone ? "22px" : isTablet ? "28px" : "34px",
    fontWeight: "700",
    color: configData.THEME_COLORS.PRIMARY,
    lineHeight: "1.2",
  };

  const subHeading = {
    marginTop: "6px",
    color: "#D84D86",
    fontSize: isPhone ? "15px" : "21px",
    fontWeight: "600",
  };

  const helperText = {
    fontSize: isPhone ? "14px" : "16px",
    color: "#5B667A",
    marginTop: "4px",
  };

  const statCard = {
    background: "#FFFFFF",
    border: "1px solid #F2DFE6",
    borderRadius: "18px",
    padding: isPhone ? "14px" : "16px 18px",
    boxShadow: "0px 12px 28px rgba(132, 90, 110, 0.08)",
  };

  const timelineWrap = {
    position: "relative",
    padding: isPhone ? "18px 16px 28px" : "28px 32px 36px",
    maxWidth: "980px",
    margin: "0 auto",
  };

  const timelineLine = {
    position: "absolute",
    top: isPhone ? "76px" : "95px",
    bottom: "36px",
    left: isPhone ? "29px" : "50%",
    transform: isPhone ? "none" : "translateX(-50%)",
    width: "3px",
    background: "linear-gradient(180deg, #F7AEC7 0%, #E8D7DE 100%)",
    borderRadius: "999px",
  };

  const statusBadge = (status) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 12px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "0.04em",
    color:
      status === "COMPLETED"
        ? "#1E8E5A"
        : status === "PENDING"
          ? "#A66700"
          : "#004AAD",
    background:
      status === "COMPLETED"
        ? "#EAF8F0"
        : status === "PENDING"
          ? "#FFF4E4"
          : "#EAF2FF",
  });

  const metaLabelStyle = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "0.05em",
    color: "#004AAD",
  };

  const renderTimelineCard = (item, index) => {
    const isLeft = index % 2 === 0;
    const status = getConsultationStatus(item);
    const summaryText = getConsultationSummaryText(item);
    const doctorImage = getDoctorImage(item);

    const rowStyle = isPhone
      ? {
        position: "relative",
        paddingLeft: "56px",
        marginBottom: "22px",
      }
      : {
        display: "grid",
        gridTemplateColumns: "1fr 64px 1fr",
        alignItems: "start",
        marginBottom: "28px",
      };

    const cardStyle = {
      background: "#FFFFFF",
      border: "1px solid #F3DDE4",
      borderRadius: isPhone ? "18px" : "22px",
      padding: isPhone ? "16px" : "20px",
      boxShadow: "0px 18px 40px rgba(126, 88, 107, 0.10)",
      width: "100%",
    };

    const cardBody = (
      <div style={cardStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div style={metaLabelStyle}>
            <img
              src="/Pregnancycare/calendar.png"
              alt="calendar"
              style={{ width: "14px", height: "14px" }}
            ></img>
            <span>{moment(item?.scheduled_date).format("MMM D, YYYY")}</span>
          </div>
          <div style={metaLabelStyle}>
            <img
              src="/Pregnancycare/weekimg.png"
              alt="week"
              style={{ width: "14px", height: "14px" }}
            ></img>
            <span>Week {item?.week || "-"}</span>
          </div>
        </div>

        <div
          style={{
            marginTop: "14px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#5B667A",
            }}
          >
            Consultation Status:
          </div>
          <div style={statusBadge(status)}>{status}</div>
        </div>

        <div
          style={{
            marginTop: "12px",
            fontSize: isPhone ? "18px" : isTablet ? "18px" : "20px",
            fontWeight: "700",
            color: "#243145",
          }}
        >
          {item?.patient_consultation_name ||
            `Consultation ${item?.consultation_number}`}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginTop: "18px",
          }}
        >
          <img
            src={doctorImage}
            alt="doctor"
            style={{
              width: isPhone ? "54px" : "62px",
              height: isPhone ? "54px" : "62px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          ></img>
          <div>
            <div
              style={{
                fontSize: isPhone ? "16px" : isTablet ? "16px" : "18px",
                fontWeight: "700",
                color: "#243145",
              }}
            >
              {item.fname} {item.lname}
            </div>
            <div
              style={{
                fontSize: isPhone ? "13px" : "14px",
                color: "#5B667A",
                marginTop: "2px",
              }}
            >
              {item.medical_expert}
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "18px",
            padding: isPhone ? "14px" : "16px",
            borderRadius: "16px",
            background: "#FFF7FA",
            border: "1px solid #F7DFE8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: "#004AAD",
              marginBottom: "8px",
              letterSpacing: "0.04em",
            }}
          >
            SUMMARY
          </div>
          <div
            style={{
              fontSize: isPhone ? "14px" : "15px",
              color: "#334155",
              lineHeight: "1.75",
            }}
          >
            {summaryText || "No Summary"}
          </div>
        </div>
      </div>
    );

    return (
      <div key={item?.id || index} style={rowStyle}>
        {isPhone ? (
          <>
            <div
              style={{
                position: "absolute",
                left: "18px",
                top: "18px",
                width: "22px",
                height: "22px",
                borderRadius: "50%",
                background: "#F0588B",
                border: "4px solid #FFE5EE",
                zIndex: 1,
              }}
            ></div>
            {cardBody}
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: isLeft ? "flex-end" : "flex-start",
              }}
            >
              {isLeft ? (
                <div style={{ maxWidth: isTablet ? "320px" : "390px" }}>
                  {cardBody}
                </div>
              ) : (
                <div></div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "84px",
                position: "relative",
                zIndex: 3,
              }}
            >
              <div
                style={{
                  width: isTablet ? "54px" : "66px",
                  height: isTablet ? "54px" : "66px",
                  borderRadius: "50%",
                  background: "#F0588B",
                  border: "8px solid #FFE5EE",
                  boxShadow: "0px 10px 25px rgba(240, 88, 139, 0.25)",
                  zIndex: 1,
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  padding: "7px 10px",
                  minWidth: isTablet ? "70px" : "82px",
                  borderRadius: "999px",
                  background: "#FFFFFF",
                  border: "1px solid #F1DEE6",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#D84D86",
                  textAlign: "center",
                  boxShadow: "0px 10px 24px rgba(113, 84, 98, 0.12)",
                  zIndex: 4,
                }}
              >
                {moment(item?.scheduled_date).format("MMM D")}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isLeft ? "flex-start" : "flex-end",
              }}
            >
              {!isLeft ? (
                <div style={{ maxWidth: isTablet ? "320px" : "390px" }}>
                  {cardBody}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="d-flex">
      <div>
        <MiniDrawer />
      </div>
      <div style={outerwrapper}>
        <div style={headerWrap}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: isPhone ? "flex-start" : "center",
              gap: "16px",
            }}
          >
            <div>
              <div style={heading}>Pregnancy Care Summary</div>
              <div style={subHeading}>Your consultation timeline</div>
              <div style={helperText}>
                Review all pregnancy care summaries in one place.
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: isPhone ? "10px" : "14px",
              }}
            >
              <NotificationsIcon
                sx={{ width: "25px", height: "25px", color: "#004AAD" }}
              />
              <Dropdown
                submenu={submenu}
                onClick={() => showsubmenu()}
                page="pregnancyCare"
              />
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isPhone
                ? "1fr"
                : "repeat(3, minmax(0, 1fr))",
              gap: "12px",
              marginTop: isPhone ? "16px" : "22px",
            }}
          >
            <div style={statCard}>
              <div
                style={{ fontSize: "12px", color: "#7A8798", fontWeight: "600" }}
              >
                TOTAL CONSULTATIONS
              </div>
              <div
                style={{
                  fontSize: isPhone ? "24px" : "28px",
                  fontWeight: "700",
                  color: "#243145",
                  marginTop: "6px",
                }}
              >
                {summaryStats.total}
              </div>
            </div>
            <div style={statCard}>
              <div
                style={{ fontSize: "12px", color: "#7A8798", fontWeight: "600" }}
              >
                COMPLETED
              </div>
              <div
                style={{
                  fontSize: isPhone ? "24px" : "28px",
                  fontWeight: "700",
                  color: "#1E8E5A",
                  marginTop: "6px",
                }}
              >
                {summaryStats.completed}
              </div>
            </div>
            <div style={statCard}>
              <div
                style={{ fontSize: "12px", color: "#7A8798", fontWeight: "600" }}
              >
                PENDING
              </div>
              <div
                style={{
                  fontSize: isPhone ? "24px" : "28px",
                  fontWeight: "700",
                  color: "#C78310",
                  marginTop: "6px",
                }}
              >
                {summaryStats.pending}
              </div>
            </div>
          </div>
        </div>

        <div style={timelineWrap}>
          {pregnancycare.length > 0 ? (
            <>
              <div style={timelineLine}></div>
              {pregnancycare.map((item, index) =>
                renderTimelineCard(item, index)
              )}
            </>
          ) : (
            <div
              style={{
                maxWidth: "520px",
                margin: "40px auto 0",
                background: "#FFFFFF",
                border: "1px solid #F3DDE4",
                borderRadius: "22px",
                padding: isPhone ? "24px 18px" : "32px",
                textAlign: "center",
                boxShadow: "0px 18px 40px rgba(126, 88, 107, 0.10)",
              }}
            >
              <div
                style={{
                  fontSize: isPhone ? "20px" : "24px",
                  fontWeight: "700",
                  color: "#D84D86",
                }}
              >
                No pregnancy care summary to show
              </div>
              <div
                style={{
                  marginTop: "10px",
                  color: "#5B667A",
                  fontSize: "15px",
                  lineHeight: "1.7",
                }}
              >
                Summary cards will appear here once consultation summaries are
                available.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PregnancyCare;
